import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useEntListQuery } from '../../store/ReactWebSiteApi';

function GetFirm(props) {
    const [list,setList] = useState();
    const {data,isSuccess} = useEntListQuery({e_name:''})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);
                
                const newArr = data.Result.map((item) => {
                    const {e_id,e_name}=item;
                    return item = {value:e_id,label:e_name,}
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
                style={props.formStyle}
            >
                <Select 
                    showSearch
                    optionFilterProp="label"
                    options={list} 
                    onChange={(_,f) => {
                        // console.log(f);
                        props.getFirm(f.value,f.label,)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.defaultId}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default GetFirm